// Client configuration access helper
// This provides typed access to the client configuration injected at build time

import { WisesheetsTheme } from './taskpane/utils/theme'

export type Clients = 'default' | 'fmp'
export interface ClientConfig {
    theme: WisesheetsTheme
    branding: {
        companyName: string
        privacyPolicyLink: string
        tosLink: string
        contactLink: string
        functionPrefix: string
        signupLink: string
        title: string
        docsLink: string
        availableDataLink: string
    }
}

// Access the config injected by webpack at build time
declare const process: {
    env: {
        CLIENT_CONFIG: ClientConfig
        CLIENT_ID: Clients
    }
}

// Export the configuration (already parsed by webpack DefinePlugin)
export const CLIENT_CONFIG: ClientConfig = process.env.CLIENT_CONFIG
export const CLIENT_ID: Clients = process.env.CLIENT_ID

// Convenience exports for commonly used values
export const THEME = CLIENT_CONFIG.theme
export const BRANDING = CLIENT_CONFIG.branding
